import { Moment } from 'moment';

export type DateRange = [Moment | null, Moment | null];

export type QuickFilter = {
  key: string;
  label: string;
  getDateRange: () => [Moment, Moment];
};

export type DateRangeOutput = {
  startDate: string | null;
  endDate: string | null;
};

export type MobileStep = 'start' | 'end';
export type CalendarView = 'year' | 'month' | 'day';

export type DateRangeTrackingEventType =
  | 'applied'
  | 'quickFilterApplied'
  | 'cleared';

export const DateRangeTrackingEvent = {
  APPLIED: 'applied',
  QUICK_FILTER_APPLIED: 'quickFilterApplied',
  CLEARED: 'cleared',
} as const satisfies Record<string, DateRangeTrackingEventType>;

export interface DateRangeTrackingEventData {
  startDate: string | null;
  endDate: string | null;
  filterKey?: string;
}
